import type { AnalyticsConfig, UseAnalyticsReturn } from './useAnalytics';

import { createContext, useContext } from 'react';

import { useAnalytics } from './useAnalytics';

export const AnalyticsContext = createContext<UseAnalyticsReturn | null>(null);

type AnalyticsProviderProps = {
  children: React.ReactNode;
  config?: AnalyticsConfig;
};

export function AnalyticsProvider({ children, config = {} }: AnalyticsProviderProps) {
  const analytics = useAnalytics(config);
  return <AnalyticsContext.Provider value={analytics}>{children}</AnalyticsContext.Provider>;
}

export function useAnalyticsContext(): UseAnalyticsReturn {
  const context = useContext(AnalyticsContext);
  if (!context) {
    throw new Error('useAnalyticsContext must be used within an AnalyticsProvider');
  }
  return context;
}
